import { axiosServices } from "./axiosServices";

export const rfqServices = { getRfqListing, getVendorRfqListing, createNewRfq, updateRFQ, changeStatus, deleteBOQ, extendValidity, getExistingVendorRfqListing, rejectRFQ, downloadVendorRFQ, downloadInternalRFQ, initiateEvaluation, getTechnicalComparison, updateVendorRFQ, deleteRFQ, techEvaluation, techFinalize, getCommercialComparison, doqnloadRfqResult, updateVendorDetails, initiateRound2, updateReverseAuctionRound2, getAssignEngineer, vendorRfqTakeAction, deleteVendor ,getRfqFieldList,getNFADetails,createnfs ,updateNfa ,updateNfaApprove , downloadNfaReport ,getNFACommercialComparison,getComparsionDetails};

function getRfqListing(param) {
    return axiosServices.getAxios(`/v1/internal/rfqs${param}`).then((res) => {
        // console.log(res);
        return res;
    });

}

function getVendorRfqListing(param) {
    return axiosServices.getAxios(`/v1/vendor/rfqs${param}`).then((res) => {
        // console.log(res);
        return res;
    });

}

function createNewRfq(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/rfqs", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateRFQ(id, bodyData) {
    return axiosServices
        .putAxios(`/v1/internal/rfqs/${id}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateVendorRFQ(id, bodyData) {
    return axiosServices
        .putAxios(`/v1/vendor/rfqs/${id}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function changeStatus(id, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${id}/update-status`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function deleteBOQ(rfqId, boqId, bodyData) {
    return axiosServices
        .deleteAxios(`/v1/internal/rfqs/${rfqId}/boqs/${boqId}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function extendValidity(id, bodyData) {
    return axiosServices
        .postAxios("/v1/internal/rfqs/extend-validity", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}


function getExistingVendorRfqListing(param) {
    return axiosServices.getAxios(`/v1/internal/vendors/existing${param}`).then((res) => {
        // console.log(res);
        return res;
    });

}

function rejectRFQ(bodyData) {
    return axiosServices
        .postAxios("/v1/vendor/rfqs/reject-rfq", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function vendorRfqTakeAction(bodyData) {
    return axiosServices
        .postAxios("/v1/vendor/rfqs/take-action", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function downloadVendorRFQ(bodyData) {
    return axiosServices
        .postAxios("/v1/vendor/rfqs/download-documents", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function downloadInternalRFQ(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/rfqs/download-documents", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function initiateEvaluation(rfqId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${rfqId}/initiate-evaluation`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getTechnicalComparison(rfqId) {
    return axiosServices.getAxios(`/v1/internal/rfqs/${rfqId}/technical-comparison`).then((res) => {
        // console.log(res);
        return res;
    });
}


function deleteRFQ(rfqId, bodyData) {
    return axiosServices
        .deleteAxios(`/v1/internal/rfqs/${rfqId}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function techEvaluation(bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/evaluate-vendor`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function techFinalize(rfqId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${rfqId}/finalize-evaluation`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getCommercialComparison(rfqId,round2) {
    return axiosServices.getAxios(`/v1/internal/rfqs/${rfqId}/commercial-comparison?round=${round2}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function doqnloadRfqResult(rfqId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${rfqId}/commercial-comparison/download`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}


function updateVendorDetails(rfqId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${rfqId}/update-vendor-details`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function initiateRound2(rfqId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${rfqId}/initiate-next-round`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateReverseAuctionRound2(rfqId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${rfqId}/upload-reverse-auction`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}
function getAssignEngineer(param) {
    return axiosServices.getAxios(`/v1/internal/steps/assignees${param}`).then((res) => {
        return res;
    });
}

function deleteVendor(vedId, bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/rfqs/${vedId}/remove-vendor`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getRfqFieldList(moduleName , page) {
    return axiosServices.getAxios(`/v1/common/field-configs?moduleName=${moduleName}&page=${page}`).then((res) => {
      return res;
  })
}

function getNFADetails(id){
    return axiosServices.getAxios(`/v1/internal/nfas/${id}`).then((res) => { 
        return res;
    });
}

function createnfs(bodyData) {
    return axiosServices
        .postAxios(`/v1/internal/nfas`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateNfa(id, bodyData) {
    return axiosServices
        .putAxios(`/v1/internal/nfas/${id}`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updateNfaApprove(bodyData){
    return axiosServices
    .postAxios(`/v1/internal/nfas/take-action`, bodyData)
    .then((res) => { 
        return res;
    });
}

function downloadNfaReport(bodyData){
    return axiosServices
    .postAxios(`/v1/internal/nfas/download`, bodyData)
    .then((res) => { 
        return res;
    });
}

function getNFACommercialComparison(rfqId, bodyData) { 
    return axiosServices.getAxios(`/v1/internal/rfqs/${rfqId}/commercial-comparison${bodyData}`).then((res) => {
       
        return res;
    });
}

function getComparsionDetails(rfqId, bodyData) { 
    return axiosServices.getAxios(`/v1/internal/rfqs/${rfqId}/nfa-ranking`).then((res) => {

        return res;
    });
}